import styled from "styled-components";

export const Container = styled.div``;

export const Item = styled.div`
  display: flex;
  justify-content: flex-start;
  padding: 10px;
  border-radius: 10px;
`;

export const List = styled.div`
  max-height: 50vh;
  overflow-y: auto;
  border: 1px solid #eee;
  border-radius: 10px;
  &::-webkit-scrollbar {
    width: 5px;
  }
  &::-webkit-scrollbar-thumb {
    background: #bbb;
  }
  & > * {
    margin-bottom: 10px;
    margin-right: 5px;
  }
`;

export const ContainerActions = styled.div`
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
  
`;

export const ContainerAddNeighborhood = styled.div`
  display: flex;
  padding: 20px;
  justify-content: center;
`;
